import { CustomLink } from 'src/components'
import { useTranslation } from 'next-i18next'
import { BigOrderItem, Order } from 'src/core/models'

interface PropsType {
  order: Order
  orderItem: BigOrderItem
}

const OrderItemFeeCertificates = ({ order, orderItem }: PropsType) => {
  const { t } = useTranslation()
  const isNotOrderPaid = order.status !== 'paid'
  const hasCustomerInvoice = orderItem.customerInvoice !== null

  const links = [
    {
      label: t('Transactions.ProformaInvoice'),
      link: orderItem.invoiceP2p,
      isDisabled: isNotOrderPaid,
      show: orderItem.invoiceP2pBaseAmount && !hasCustomerInvoice
    },
    {
      label: t('Transactions.TransactionFee'),
      link: orderItem.invoiceFeeUrl,
      isDisabled: isNotOrderPaid,
      show: orderItem.invoiceFeeBaseAmount && !hasCustomerInvoice
    }
  ]

  return (
    <>
      {links.map((link, idx) => (
        <div key={idx}>
          {link.show && (
            <CustomLink
              label={link.label}
              link={link.link}
              isDisabled={link.isDisabled}
            />
          )}
        </div>
      ))}
    </>
  )
}

export default OrderItemFeeCertificates
